import React from 'react';
import logo from '../assets/icon.png';

// Marca do Orion. Mesmo papel do LogoNexus lá: uma imagem, não um ícone
// genérico de traço — a marca precisa ser reconhecível na bandeja, no login e
// no canto da barra lateral.
export default function LogoOrion({ size = 24, className = '', title = 'Orion' }) {
  return (
    <img
      src={logo}
      height={size}
      alt={title}
      title={title}
      className={`logo-orion ${className}`}
      draggable="false"
    />
  );
}
